const Vue = require('vue')
import Vuet from 'vuet'
import api from '@/util/api'
import config from '@/util/config'


import plugins from '@/util/vueplugins'
Vue.use(plugins)
Vue.use(Vuet)

import user from './user'
import order from './order'
import app from './app'

var home = {
  data() {
    return {
      id: 0,
      list: []
    }
  },
  fetch() {
    this.$api.menu.getall().then((res) => {
      if (res.R) {
        this.list = res.data;
      }
    })
  }
}

var root = {
  data() {
    return {
      fetchlist: [],
      loaded: false, // 页面是否加载(网页第一打开标志 )
      showLogin: false,
      login_callback: null
    }
  },
  clear() {
    this.fetchlist = []
  },
  modules: {
    user,
    home,
    order,
    app
  }
}

export default new Vuet({
  pathJoin: '/',
  modules: {
    root
  }
})
